import { Component, Vue, toNative } from "vue-facing-decorator";
import { nextTick } from "vue";

@Component
class heightCalculationsMixin extends Vue {
  indexOfMaxHeight(arr, selector) {
    // console.log("arr", arr);
    const _this = this;
    if (arr.length === 0) {
      return -1;
    }

    let max = 0;
    let maxIndex = 0;

    for (let i = 0; i < arr.length; i++) {
      const errorWrap = arr[i].querySelector(selector);

      _this.clearHeights(arr[i], selector);

      if (errorWrap && _this.outerHeight(errorWrap) > max) {
        maxIndex = i;
        max = _this.outerHeight(errorWrap);
      }
    }
    return maxIndex;
  }

  outerHeight(el) {
    // console.log("outerheight of.. ", el);
    if (!el) {
      return 0;
    }
    let height = el.offsetHeight;
    const style = getComputedStyle(el);

    height +=
      parseInt(style.marginTop ? style.marginTop : "0") +
      parseInt(style.marginBottom ? style.marginBottom : "0");
    return isNaN(height) ? 0 : height;
  }

  sizeSpacers(element, wrapperSelector, errorSelector, spacerSelector) {
    const _this = this;
    if (element) {
      let joinedWrappers = element.querySelectorAll(wrapperSelector);
      let errorWrappers = element.querySelectorAll(
        wrapperSelector + " " + errorSelector
      ); //get all error wrappers - only inside joinedfieldswrap

      let indexOfHighest =
        errorWrappers.length > 0
          ? this.indexOfMaxHeight(joinedWrappers, errorSelector)
          : -1; //get index of element with juiciest error container - in the array of all error wrappers
      Array.prototype.forEach.call(joinedWrappers, function (wrap, i) {
        _this.clearHeights(wrap, errorSelector);
        _this.clearHeights(wrap, spacerSelector);
      });

      let theMaxHeight =
        indexOfHighest >= 0
          ? this.outerHeight(
              joinedWrappers[indexOfHighest].querySelector(errorSelector)
            )
          : -1; //get the actual height of the juiciest error container

      if (theMaxHeight > 0) {
        _this.$nextTick(function () {
          Array.prototype.forEach.call(joinedWrappers, function (wrap, i) {
            //go through children, and adjust the spacer so it takes same space
            const errorWrap = wrap.querySelector(errorSelector);

            if (errorWrap && indexOfHighest !== i) {
              _this.setHeight(errorWrap, theMaxHeight);
              _this.clearHeights(wrap, spacerSelector);
            } else {
              _this.clearHeights(wrap, errorSelector);
              _this.clearHeights(wrap, spacerSelector);
            }

            if (!errorWrap) {
              _this.setHeight(wrap.querySelector(spacerSelector), theMaxHeight);
            }
          });
        }); //eof next tick
      } //
    }
  }

  clearHeights(element, selector) {
    if (element.querySelector(selector)) {
      element.querySelector(selector).style.height = null;
      element.querySelector(selector).classList.remove("custom-height");
    }
  }

  setHeight(element, height) {
    if (element) {
      nextTick(function () {
        element.style.height = height.toString() + "px";
        element.classList.add("custom-height");
      });
    }
  }
}

export default toNative(heightCalculationsMixin);
